import React, { FC } from 'react';
import { TypeDisclaimerFields } from '@/core/generated-types';
import { LuvImage } from '@/components/ui';
import classNames from 'classnames';
import { TW_BORDER_COLORS } from '@/core/constants';

const Disclaimer: FC<TypeDisclaimerFields> = ({
  showWarningTitle,
  warningTitle,
  warningDescription,
  disclaimerImage,
  borderColor,
}) => {
  const { color } = borderColor?.fields || {};
  // TODO: Find a better solution to avoid type errors when the list of colors in Contentful is updated.
  const borderColorString = color ? `border ${TW_BORDER_COLORS[color]}` : '';

  return (
    <div
      className={classNames(
        `container relative mx-auto mb-10 flex items-center p-4 ${borderColorString} mt-12 w-[328px] max-w-[1128px] rounded-md border-solid md:mt-8 md:w-[90vw]`,
      )}
      data-testid="disclaimer"
    >
      {disclaimerImage && (
        <LuvImage
          {...disclaimerImage.fields}
          height={100}
          width={100}
          className={
            'absolute top-[20px] mr-4 w-[40px] md:relative md:top-0 md:w-[50px]'
          }
        />
      )}
      <p className={`ml-14 md:ml-0`}>
        {showWarningTitle && <strong>{warningTitle}</strong>}{' '}
        {warningDescription}
      </p>
    </div>
  );
};

export default React.memo(Disclaimer);
